var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Unavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "26px",
    height: "26px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(9.84615,9.84615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,1c-6.61719,0 -12,5.38281 -12,12c0,6.61719 5.38281,12 12,12c6.61719,0 12,-5.38281 12,-12c0,-6.61719 -5.38281,-12 -12,-12zM13,3c5.53516,0 10,4.46484 10,10c0,2.40625 -0.83984,4.62109 -2.25,6.34375l-14.09375,-14.09375c1.72266,-1.41016 3.9375,-2.25 6.34375,-2.25zM5.25,6.65625l14.09375,14.09375c-1.72266,1.41016 -3.9375,2.25 -6.34375,2.25c-5.53516,0 -10,-4.46484 -10,-10c0,-2.40625 0.83984,-4.62109 2.25,-6.34375z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Unavailable);
export default __webpack_public_path__ + "static/media/icons8-unavailable.2719046233ec4db59135a88d47496347.svg";
export { ForwardRef as ReactComponent };